module.exports = __webpack_public_path__ + "static/img/bg.d45cd3f3.png";